import { useModuleBEM, useUiStyles } from "@b2bportal/core-themes";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import { CoreUiComponents } from "@b2bportal/core-types";
import clsx from "clsx";
import defaultStyles from "./SkeletonLoading.module.scss";

type SkeletonLoadingProps = PlatformComponentProps & {
  height?: string;
};
export const SkeletonLoading = ({ className }: SkeletonLoadingProps) => {
  const styles = useUiStyles(CoreUiComponents.SkeletonLoading, defaultStyles);
  const [block, cn] = useModuleBEM(styles, CoreUiComponents.SkeletonLoading);

  return <div className={clsx(cn("loader"), className)} />;
};

export const SkeletonLoadingContainer = ({
  className,
  children,
}: SkeletonLoadingProps) => {
  const styles = useUiStyles(CoreUiComponents.SkeletonLoading, defaultStyles);
  const [block, cn] = useModuleBEM(styles, CoreUiComponents.SkeletonLoading);

  return <div className={clsx(cn("container"), className)}>{children}</div>;
};
